import type { FaireProductEntity } from "../../entity_types/product";

export const p_3nv7h6t74n: FaireProductEntity = {
  token: "p_3nv7h6t74n",
  type: "product",
  name: "Women's Fuzzy Crew Socks with Non-Slip Grippers",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/ba6c215fdfe807af98df1e00b43b0fe9635cb4d58230f9423f658e3d3a442b12.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/839c709c209baa448ca4584e9bcc5de196a7957c88c2b83bef9215d4e9208f1c.png",
    "https://cdn.faire.com/fastly/61d425da65ccc2f0d2c80c914b048502eb06e37c70b31df0559721a4b568035f.png",
    "https://cdn.faire.com/fastly/e97a714f93d286b147bf38b3782e94dd89951e2d65006f3c8e7e88431ca8b1eb.png"
  ],
  priceDollars: 13,
  description: "Step into comfort with our signature Marshmallow Crew Socks, crafted from decadently soft fabric with delicate ribbing for a cozy feel. No-slip gripper bottoms make them perfect for lounging at home, while their giftable appeal makes them an easy choice for holiday gifting, Valentine’s Day, and everyday self-care.\n\nOur signature Marshmallow fabric makes them decadently soft, making it the perfect gift for just about anyone–especially expectant mothers. Kick up your feet in a pair of socks you’ll never want to take off.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• Crew length\n• Non-slip grippers\n• Cozy Marshmallow fabric",
  tags: [],
  msrpDollars: 26,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:46:58.989Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
